import Detector from './Detector.js';
import HowToPlayCard from "../components/Cards/HowToPlayCard";

export default {
  mounted() { },
  data() {
    return {};
  },
  components: {
    HowToPlayCard
  },
  methods: {
    setZIndexesForStart(highEl, lowEl) {
      TweenMax.set(lowEl, {
        zIndex: 10
      });

      TweenMax.set(highEl, {
        zIndex: 1000
      });
    },
    mountPlaneAnim(planeAnimType) {
      console.log(this.$refs.three);
      console.log(this.$bus.scenesLoaded);
      if (!this.$bus.scenesLoaded) {
        this.$bus.$on("scenes-loaded", () => {
          this.handleSceneLoaded(planeAnimType);
        });
      } else {
        this.handleSceneLoaded(planeAnimType);
      }
    },
    handleSceneLoaded(planeAnimType) {
      console.log("Scenes loaded");
      this.$bus.scene = planeAnimType === 'commercial' ? this.$bus.commercialScene : this.$bus.residentialScene;

      this.$store.dispatch('switchBuilding', planeAnimType).then(() => {
        this.$bus.roomAmount = this.$store.getters.getRooms.length;
      });

      // if(planeAnimType === 'commercial') {
      //   this.$bus.scene.children[0].children[0].visible = false;
      //   console.log('this.$bus.scene:  ', this.$bus.scene);
      // }

      this.elements.container = planeAnimType === 'commercial' ? document.querySelector('#three-commercial-container') : document.querySelector('#three-residential-container');
      this.mouse.x = Infinity;
      this.mouse.y = Infinity;

      this.clock = new THREE.Clock();

      this.camera = new THREE.PerspectiveCamera(
        70,
        this.elements.container.clientWidth /
        this.elements.container.clientHeight,
        0.01,
        2000
      );
      this.camera.position.z = 7;
      this.camera.position.y = 3.5;
      this.camera.rotateY(90);

      this.renderer = Detector.webgl
        ? new THREE.WebGLRenderer({ antialias: true, alpha: true })
        : new THREE.CanvasRenderer({ antialias: true, alpha: true });

      if (planeAnimType === 'commercial') {
        this.renderer.gammaOutput = true;
      } else {
        this.renderer.gammaOutput = false;
      }

      this.renderer.setSize(
        this.elements.container.clientWidth / 2,
        this.elements.container.clientHeight
      );

      this.elements.container.appendChild(this.renderer.domElement);
      this.renderer.domElement.style.position = 'fixed';

      if (planeAnimType === 'commercial') {
        this.renderer.domElement.style.left = '0px';
      } else {
        this.renderer.domElement.style.right = '0px';
      }

      this.renderer.domElement.style.top = '0px';
      this.GetContainerDimensions();

      this.LoadScene();

      this.raycaster = new THREE.Raycaster();
      this.raycaster.params.Points.threshold = 0.1;

      this.animate();

      window.addEventListener('snapStartEvent', this.handleCameraSnapStart);

      window.addEventListener('snapEndEvent', this.handleCameraSnapEnd);

      // setInterval(() => {
      // console.log('this.appState:  ', this.appState);
      // console.log('this.showingQuestion:  ', this.showingQuestion);
      // console.log('this.roomObjs:  ', this.roomObjs);
      // }, 1000);
    }
  }
};



// WEBPACK FOOTER //
// ./src/plugins/PlaneAnimMixin.js